
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import socket from './socket';

Vue.config.productionTip = false;

// Gắn socket vào Vue prototype để dùng ở mọi component
Vue.prototype.$socket = socket;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
